import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import "../../../../../App.css";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomSelect from "../../../../components/main_comps/custom_select";
import { AiOutlineEye } from "react-icons/ai";
import {
  Add,
  SymAdd,
  ViewIcon,
  Upwardarrow,
  UpwardArrow,
  Eyelight,
} from "../../../../../utility/constants/assetsManager";
import CustomUploadField2 from "../../../../components/ui_comps/CustomUploadField2";
import {
  checkAnyOneObjHasAllValue,
  checkObjHasAllValue,
} from "../../../../components/ui_comps/ComissionContainer";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";

const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
        style={{
          fontWeight: "400",
          fontSize: "16px",
        }}
      />
      <label
        style={{
          fontWeight: "400",
          fontSize: "16px",
          color: "#1E2234",
          padding: "2px 0 0 7px",
        }}
        htmlFor={id}
      >
        {title}
      </label>
    </div>
  );
};

function KycDetailsNew({
  onClickNext,
  onClickPrevious,
  reduxData,
  onClickCancel,
}) {
  const [kycClientOpted, setKycClientOpted] = useState("yes");
  const [service, setService] = useState("ROLLING");
  const [rolling, setRolling] = useState("");
  const [securityDeposit, setSecurityDeposit] = useState("");
  const [video, setVideo] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",

    color: "#000000",
  };
  const containerStyle = {
    width: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px",
  };

  useEffect(() => {
    if (reduxData?.rollbackReserves || reduxData?.security) {
      if (reduxData?.isKycVerified) {
        const roll = JSON.parse(reduxData?.rollbackReserves);
        const secure = JSON.parse(reduxData?.security);
        setVideo(reduxData?.videoKycUrl);
        if (roll?.status) {
          setRolling(roll?.percentage);
          setService("ROLLING");
        } else {
          setSecurityDeposit(secure?.amount / 100);
          setService("DEPOSIT");
        }
      } else {
       const roll = JSON.parse(reduxData?.rollbackReserves);
        const secure = JSON.parse(reduxData?.security);

        setRolling(roll?.percentage);
        setSecurityDeposit(secure?.amount / 100);
      }
      setKycClientOpted(reduxData?.isKycVerified ? "yes" : "no");
    }
  }, [reduxData]);

  return (
    <div style={{ width: "100%", alignItems: "center", marginTop: "20px" }}>
      <div>
        <p style={styles.title}>Upload Documents</p>
      </div>
      <p style={styles.p}>Provide the Valid Documents as Mentioned below</p>
      <div
        style={{
          margin: "10px 0 20px 0",
          height: "1px",
          background: "#38369C",
        }}
      ></div>

      <div
        style={{
          fontWeight: "400",
          fontSize: "16px",
          color: "#1E2234",
        }}
      >
        Has the Client Opted for the VKYC ?
      </div>
      <div
        style={{
          display: "flex",
          marginTop: 15,
          gap: 50,
          marginBottom: "20px",
        }}
      >
        <RadioButton
          id="yes"
          name="yes_radio"
          title="Yes"
          value="yes"
          onChange={(val) => {
            setKycClientOpted(val.target.value);
            setRolling("");
            setSecurityDeposit("");
            setVideo("");
          }}
          defaultChecked={kycClientOpted === "yes"}
        />
        <RadioButton
          id="no"
          name="yes_radio"
          title="No"
          value="no"
          onChange={(val) => {
            setKycClientOpted(val.target.value);
            setRolling("");
            setSecurityDeposit("");
            setVideo("");
          }}
          defaultChecked={kycClientOpted === "no"}
        />
      </div>
      {kycClientOpted === "yes" ? (
        <div>
          <p style={styles.docName}>Upload Video</p>
          <CustomUploadField2
            document="Upload Video"
            value={reduxData?.videoKycUrl ? reduxData?.videoKycUrl : ""}
            onChange={(data) => {
              setVideo(data);
            }}
            onClickRemove={() => {
              setVideo("");
            }}
            imageTypeArray={["mp4"]}
            filesize={60}
            customIcon={<Upwardarrow />}
            accept={".mp4"}
            // isDownloadFileRequired="true"
          />
          <p
            style={{
              fontWeight: "400",
              fontSize: "16px",
            }}
          >
            Video format should be .mp4
          </p>
          <div style={{ display: "flex", margin: "20px 0 15px -10px" }}>
            <RadioButton
              titleStyle={{
                fontSize: "14px",
                // color: " #000E49",
                fontWeight: "400",
                marginLeft: "15px",
                // color: currentValue === "ROLLING" ? "#989CFF" : "#000E49",
              }}
              name="Rolling_Reserve"
              title="Rolling Reserve"
              value="ROLLING"
              onChange={(val) => {
                setService(val.target.value);
                setSecurityDeposit("");
              }}
              defaultChecked={service === "ROLLING"}
              style={{
                marginRight: "30px",
              }}
            />

            <RadioButton
              titleStyle={{
                fontSize: "14px",
                // color: " #000E49",
                fontWeight: "400",
                // color: currentValue === "DEPOSIT" ? "#989CFF" : "#000E49",
              }}
              name="Rolling_Reserve"
              title="Security Deposit"
              value="DEPOSIT"
              onChange={(val) => {
                setService(val.target.value);
                setRolling("");
              }}
              defaultChecked={service === "DEPOSIT"}
            />
          </div>
          {service === "ROLLING" ? (
            <div>
              <label style={styles.label}>Enter the rolling reserve</label>
              <CustomInput
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="eg:5%"
                validator="number"
                maxLength={2}
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
                // value={
                //   reduxData?.rollbackReserves ? reduxData?.rollbackReserves : ""
                // }
                value={rolling}
                onChange={(data) => {
                  setRolling(data);
                }}
              />
            </div>
          ) : (
            <div>
              <label style={styles.label}>Enter the Security deposit</label>
              <CustomInput
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Enter the amount"
                type="input"
                validator="number"
                inputStyles={{
                  ...containerStyle,
                }}
                //value={reduxData?.security ? reduxData?.security : ""}
                value={securityDeposit}
                onChange={(data) => {
                  setSecurityDeposit(data);
                }}
              />
            </div>
          )}
        </div>
      ) : (
        <>
          <div>
            <label style={styles.label}>Enter the rolling reserve</label>
            <CustomInput
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="eg:5%"
              validator="number"
              maxLength={2}
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
              value={rolling}
              // value={
              //   reduxData?.rollbackReserves ? reduxData?.rollbackReserves : ""
              // }
              onChange={(data) => {
                setRolling(data);
              }}
            />

            <div>
              <label style={styles.label}>Enter the Security deposit</label>
              <CustomInput
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Enter the amount"
                type="input"
                validator="number"
                inputStyles={{
                  ...containerStyle,
                }}
                value={securityDeposit}
                // value={
                //   reduxData?.securityDeposit ? reduxData?.securityDeposit : ""
                // }
                onChange={(data) => {
                  setSecurityDeposit(data);
                }}
              />
            </div>
          </div>
        </>
      )}

      <div style={{ display: "flex", marginTop: "40px", marginBottom: "20px" }}>
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              let rollbackReserves = {};
              let security = {};

              if (kycClientOpted === "yes") {
                if (service === "ROLLING") {
                  rollbackReserves = {
                    status: true,
                    percentage: rolling,
                  };
                } else {
                  rollbackReserves = {
                    status: false,
                    percentage: 0,
                  };
                }
                if (service === "DEPOSIT") {
                  security = {
                    status: true,
                    amount: securityDeposit * 100,
                  };
                } else {
                  security = {
                    status: false,
                    amount: 0,
                  };
                }
              } else {
                rollbackReserves = {
                  status: true,
                  percentage: rolling,
                };
                security = {
                  status: true,
                  amount: securityDeposit * 100,
                };
              }

              if (kycClientOpted === "yes") {
                if (video && (rolling !== "" || securityDeposit !== "")) {
                  onClickNext({
                    videoKycUrl: video,
                    rollbackReserves: JSON.stringify(rollbackReserves),
                    security: JSON.stringify(security),
                    isKycVerified: kycClientOpted === "yes",
                  });
                } else {
                  if (!video) {
                    enqueueSnackbar("Please upload video", {
                      variant: "error",
                    });
                  } else {
                    enqueueSnackbar(
                      "Please Enter Security deposit or rolling reserve",
                      {
                        variant: "error",
                      }
                    );
                  }
                }
              } else {
                if (rolling !== "" && securityDeposit !== "") {
                  onClickNext({
                    rollbackReserves: JSON.stringify(rollbackReserves),
                    security: JSON.stringify(security),
                    isKycVerified: kycClientOpted === "yes",
                    videoKycUrl: "",
                  });
                } else {
                  enqueueSnackbar("Please fill all the details", {
                    variant: "error",
                  });
                }
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KycDetailsNew;

const styles = {
  title: {
    fontSize: "24px",

    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "300px",
  },
  p: {
    color: "#6C6B6B",

    fontWeight: "400",
    fontSize: "14px",
  },
  label: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "20px",
    color: "#1E2234",
  },
  cancel: {
    width: "56px",
    height: "19px",

    // background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px",
  },
  add: {
    width: "198px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "8px",
  },
  docName: {
    fontWeight: "500",
    fontSize: "12px",
    color: "#6C6B6B",
  },
};

// export default KycDetailsNew;
